export default __webpack_public_path__ + "static/media/WrestlingLogo.83d5c84d.png";